
// Formats an ISO date string in the format "2025-01-23"
export function getIsoDate(date: Date): string {
    return date.toISOString().split("T")[0];
}

// Formats in the format Feb 14 - Mar 21 or just Feb 14
export function formatDateRangeSimple(
    startMs: number,
    endMs: number,
    timeZone: string,
): string {
    const startDate = new Date(startMs);
    const endDate = new Date(endMs);

    const dateFormatter = new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        timeZone,
    });

    const startStr = dateFormatter.format(startDate);

    if (startMs === endMs) {
        return startStr; // e.g., "Mar 3"
    } else {
        const endStr = dateFormatter.format(endDate);
        return `${startStr} - ${endStr}`; // e.g., "Mar 3 - Apr 7"
    }
}

export function getTimezoneAbbreviation(timeZoneID: string): string {
    switch (timeZoneID) {
        case "America/New_York":
            return "ET";
        case "America/Chicago":
            return "CT";
        case "America/Denver":
            return "MT";
        case "America/Los_Angeles":
            return "PT";
        case "Pacific/Honolulu":
            return "HT";
        case "America/Anchorage":
            return "AKT";
        case "America/Halifax":
            return "AT";
        case "America/St_Johns":
            return "NT";
        default:
            try {
                const formatter = new Intl.DateTimeFormat("en-US", {
                    timeZone: timeZoneID,
                    timeZoneName: "short",
                });
                const parts = formatter.formatToParts(new Date());
                const timeZonePart = parts.find((part) =>
                    part.type === "timeZoneName"
                );
                return timeZonePart ? timeZonePart.value : timeZoneID;
            } catch {
                return timeZoneID;
            }
    }
}
